import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'rg-sortable-list',
    template: `
    <rg-sortable-item *ngFor="let item of items; let index = index"
        dragSortable
        [item]="item"
        [itemIndex]="index"
        [sortableElSelector]="'rg-sortable-item'"
        [displayExpr]="displayExpr"
        [iconExpr]="icon"
        (dropSortable)="onDrop($event)">
    </rg-sortable-item>
  `,
    styles: [`:host{display:block;background:#fff;--border:1px solid #ddd;padding:5px}rg-sortable-item{--margin-bottom:15px;overflow:hidden;transition:height .4s ease-out}rg-sortable-item.safari-specific{transition:none}rg-sortable-item.collapsed{--height:60px!important}rg-sortable-item.dragging{--outline:1px solid #ddd;border:1px solid #ddd}rg-sortable-item.grabbable{cursor:move;cursor:grab;cursor:-webkit-grab}rg-sortable-item.grabbable:active{cursor:grabbing;cursor:-webkit-grabbing}`]
})
export class SortableListComponent implements OnInit {
    @Input() items: any[];
    @Input() displayExpr: string;
    @Input() icon: string;

    constructor() { }

    onDrop(event) {
        console.log(event);
    }

    ngOnInit() { }
}
